module.exports = __webpack_public_path__ + "static/media/expanding_yellow.796fbc48.png";